const key = '8cc8480b1045cc88fba55071b5ff0ece';
const template = 'ljp_f';
const mention = ['18757567457'];
export const sendError = ({
  request,
  title,
  desc = '',
  pl = 'web',
  url
}) => {
  // 过滤ddMessage发的请求
  if (~desc.indexOf('dingTalkWarning')) return;
  const headRow = `## 异常报警---${pl}`;
  const titleRow = `## ${title}`;
  const descRow = desc;
  const msg = {
    msgtype: 'markdown',
    markdown: {
      title: '报警',
      text: `${headRow}  \n${titleRow}  \n${descRow}`
    },
    atMobiles: mention
  };
  if (pl === 'web') {
    request(url, {
      method: 'POST',
      data: {
        key,
        template,
        data: JSON.stringify(msg)
      },
      success: res => {},
      fail: error => {}
    });
  } else {
    request({
      url: url,
      method: 'POST',
      data: {
        key,
        template,
        data: JSON.stringify(msg)
      },
      success: res => {},
      fail: error => {}
    });
  }
};